// -----------------------------------------------------------
// This is a very basic event bus made with an instance of Vue
// Learn more: https://alligator.io/vuejs/global-event-bus/
// Alternative: https://www.npmjs.com/package/vue-events
// -----------------------------------------------------------

import Vue from 'vue';

const EventUtil = new Vue();

export default EventUtil;


// WEBPACK FOOTER //
// ./src/utils/event.util.js